import React, { useEffect } from "react";
import "./not-found-page.css";
import { Modal } from "../../components/Modals/ModalComponent/Modal";
import ModalDividerLine from "../../components/Modals/ModalComponent/modal-divider-line";
import { Link, useNavigate } from "react-router-dom";
import warningIcon from "../../assets/images/warning.png";
import { DisableAutoLoginTemp } from "../../utils/genericUtils";
import { useContext } from "react";
import { UserContext } from "../../context/UserContext";
import { API_URL } from "../../environmentVariables";

export default function PageNotFound() {
  const header = "Page Not Found";
  const message = "Oops! The page you're looking for doesn't exist or has been moved.";
  const showDivider = true;
  const router = useNavigate();
  const { user, loginUser } = useContext(UserContext);

  useEffect(() => {
    if (user == null) {
      if (localStorage.getItem("jwt")) {
        let jwt = localStorage.getItem("jwt");
        AutoLoginNoRedirect(jwt);
      }
    }
  }, []);

  function AutoLoginNoRedirect(jwt) {
    let request = new XMLHttpRequest();
    request.open("POST", API_URL + "/jwtlogin");
    request.setRequestHeader("Authorization", jwt);
    request.send();
    request.onload = () => {
      let response = JSON.parse(request.response);
      if (response.success) {
        loginUser(response.user);
      } else {
        sessionStorage.removeItem("jwt");
        localStorage.removeItem("jwt");
      }
    };

    request.onerror = () => {
      sessionStorage.removeItem("jwt");
      localStorage.removeItem("jwt");
    };
  }

  function RenderNotFoundLinks() {
    let links = [];
    let possibleLinks = [
      {
        text: "Home",
        isPublic: true,
        path: "/",
      },
      {
        text: "Login",
        isPublic: true,
        path: "/login",
      },
      {
        text: "Register",
        isPublic: true,
        path: "/register",
      },
      {
        text: "Dashboard",
        isPublic: false,
        path: "/dashboard",
      },
      {
        text: "Settings",
        isPublic: false,
        path: "/settings",
      },
    ];
    possibleLinks.map((link, i) => {
      if (!link.isPublic) {
        links.push(
          <li key={i}>
            <Link
              onClick={(e) => {
                e.preventDefault();
                DisableAutoLoginTemp();
                router(link.path);
              }}
            >
              {link.text}
            </Link>
          </li>
        );
      } else {
        links.push(
          <li key={i}>
            <Link to={link.path}>{link.text}</Link>
          </li>
        );
      }
    });
    return links;
  }

  return (
    <section>
      <Modal
        id={"pg_404"}
        icon={warningIcon}
        showDivider={showDivider}
        isActive={true}
        header={header}
        message={message}
        animate={false}
        bg_opacity={0.5}
        width={"80%"}
      >
        <section className="pg-404-modal-body">
          <h3>Here are some helpful links to get you back on track:</h3>

          <ul className="pg-404-links">{RenderNotFoundLinks()}</ul>
          <ModalDividerLine showDivider={showDivider} />
          <p className="contact-text">If you believe this is a mistake, please {<Link to="/contact">contact our support team.</Link>}</p>
        </section>
      </Modal>
    </section>
  );
}
